import axios from "axios";
import { toast } from "react-toastify";
import environment from "../environments/environment";

interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  id?: string;
  type?: string;
  file?: any;
  key?: any;
}

const WebService = {
  getAccesstoken: function (props: PropData) {
    this.addLoader(props?.id);
    let url = this.getBaseUrl(props.type);
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }

      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "A-Platform": "web",
        "A-Lng": "en-US",
        "A-Api": "1.1"
      };
      axios
        .post(`${url}${props.action}`, bodyFormData, {
          headers: headers,
        })
        .then((response) => {
          if (typeof window !== "undefined" && response.data.token) {
            localStorage.setItem("token", response.data.token);
          }
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          this.removeLoader(props?.id);
          reject(this.errorHandler(error));
        });
    });
  },

postAPI: function <T>(props: PropData) {
  this.addLoader(props?.id);
  let url = this.getBaseUrl(props.type);

  return new Promise<T>((resolve, reject) => {
    const isFormData = typeof FormData !== "undefined" && props.body instanceof FormData;
    axios
      .post(`${url}${props.action}`, props.body, {
        headers: isFormData ? this.getMultipartHeaders() : this.getHeaders(),
      })
      .then((response) => {
        if (typeof window !== "undefined" && response.data.token) {
          localStorage.setItem("token", response.data.token);
        }
        resolve(response.data);
        this.removeLoader(props?.id);
      })
      .catch((error) => {
        if (props.action !== "/v1/door-management/login" && this.handleSessionError(error)) {
          this.removeLoader(props?.id);
          return;
        }
        this.removeLoader(props?.id);
        reject(this.errorHandler(error, props.isShowError));
      });
  });
},



putAPI: function <T>(props: PropData) {
  this.addLoader(props?.id);
  let url = this.getBaseUrl(props.type);

  return new Promise<T>((resolve, reject) => {
    // Detect FormData (file upload/multipart)
    const isFormData = typeof FormData !== "undefined" && props.body instanceof FormData;
    axios
      .put(
        `${url}${props.action}`,
        props.body,
        {
          headers: isFormData ? this.getMultipartHeaders() : this.getHeaders(),
        }
      )
      .then((response) => {
        if (typeof window !== "undefined" && response.data.token) {
          localStorage.setItem("token", response.data.token);
        }
        resolve(response.data);
        this.removeLoader(props?.id);
      })
      .catch((error) => {
        if (this.handleSessionError(error)) {
          this.removeLoader(props?.id);
          return;
        }
        this.removeLoader(props?.id);
        reject(this.errorHandler(error, props.isShowError));
      });
  });
},


 
  patchAPI: function (props: PropData) {
    this.addLoader(props?.id);
    let url = this.getBaseUrl(props.type);
    return new Promise((resolve, reject) => {
      axios
        .patch(`${url}${props.action}`, props.body, {
          headers: this.getHeaders(),
        })
        .then((response) => {
          if (typeof window !== "undefined" && response.data.token) {
            localStorage.setItem("token", response.data.token);
          }
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          if (this.handleSessionError(error)) {
            this.removeLoader(props?.id);
            return;
          }
          this.removeLoader(props?.id);
          reject(this.errorHandler(error, props.isShowError));
        });
    });
  },

  getAPI: function <T>(props: PropData, role_id?: number) {
    this.addLoader(props?.id);
    let url = this.getBaseUrl(props.type);
    return new Promise<T>(async (resolve, reject) => {
      await axios
        .get(`${url}${props.action}`, {
          headers: this.getHeaders(),
        })
        .then((response) => {
          if (typeof window !== "undefined" && response.data.token) {
            localStorage.setItem("token", response.data.token);
          }
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          if (this.handleSessionError(error)) {
            this.removeLoader(props?.id);
            return;
          }
          this.removeLoader(props?.id);
          reject(this.errorHandler(error, props.isShowError));
        });
    });
  },

  deleteAPI: function (props: PropData) {
    this.addLoader(props?.id);
    let url = this.getBaseUrl(props.type);
    return new Promise((resolve, reject) => {
      axios
        .delete(`${url}${props.action}`, {
          headers: this.getHeaders(),
        })
        .then((response) => {
          if (typeof window !== "undefined" && response.data.token) {
            localStorage.setItem("token", response.data.token);
          }
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          if (this.handleSessionError(error)) {
            this.removeLoader(props?.id);
            return;
          }
          this.removeLoader(props?.id);
          reject(this.errorHandler(error));
        });
    });
  },

  fileUploadAPI: function (props: PropData) {
    var formData = new FormData();
    if (!props.key) {
      props.key = "file";
    }
    formData.append(props.key, props.file);
    for (let key in props.body) {
      formData.append(key, props.body[key]);
    }
    this.addLoader(props?.id);
    let url = this.getBaseUrl();
    return new Promise((resolve, reject) => {
      axios
        .post(`${url}${props.action}`, formData, {
          headers: this.getMultipartHeaders(),
        })
        .then((response) => {
          if (typeof window !== "undefined" && response.data.token) {
            localStorage.setItem("token", response.data.token);
          }
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          this.removeLoader(props?.id);
          if (this.handleSessionError(error)) return;
          reject(this.errorHandler(error));
        });
    });
  },

  getHeaders: function () {
    let headers: any = {
      "Content-Type": "application/json",
      "A-Platform": "web",
      "A-Lng": "en-US",
      "A-Api": "1.1"
    };  

    if (typeof window !== "undefined" && localStorage.getItem("token")) {
      headers["Authorization"] = localStorage.getItem("token");
    }
    return headers;
  },

  getMultipartHeaders: function () {
    let headers: any = {
      "A-Platform": "web",
      "A-Lng": "en-US",
      "A-Api": "1.1"
    };
    if (typeof window !== "undefined" && localStorage.getItem("token")) {
      headers["Authorization"] = localStorage.getItem("token");
    }
    return headers;
  },

  errorHandler: function (error: any, showErrorOnPopup?: boolean) {
    const response = error?.response || error;
    const status = response?.status;
    const data = response?.data;
    const apiMessage =
      data?.message ||
      data?.ErrorDetails?.message ||
      (typeof data === "string" ? data : null);

    let errorMessage = "Something went wrong. Please try again.";

    if (!status) {
      errorMessage = "Network error. Please try again.";
    } else if (status === 401) {
      // Auth failures (e.g. wrong password on login) — return API message.
      // Session redirect is handled by callers for non-login requests.
      errorMessage = apiMessage || "Invalid mobile number or password.";
    } else if (status === 403) {
      errorMessage = apiMessage || "Access denied.";
    } else if (status === 404) {
      errorMessage = apiMessage || "Not found.";
    } else if (status === 500) {
      errorMessage =
        apiMessage ||
        "An unknown exception has occurred. Please contact administrator.";
    } else if (apiMessage) {
      errorMessage = apiMessage;
    }

    // isShowError: false → suppress toast (Login shows its own). Default shows toast.
    if (showErrorOnPopup !== false) {
      toast.error(errorMessage, { theme: "colored" });
    }
    return errorMessage;
  },

  addLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = true;
        var loader = document.createElement("img");
        loader.src = "/images/loading.gif";
        loader.className = "button-loader";
        button.prepend(loader);
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = false;
        button.removeChild(button.childNodes[0]);
      }
    }
  },
  

  downloadFileAPI: function (props: { action: string; method?: string; body?: any; }) {
    
    let url = this.getBaseUrl();
    
    const method = props.method || "GET";

   
    const config: any = {
      url: `${url}${props.action}`,
      method,
      responseType: "blob",
      headers: this.getHeaders(),
      
      ...(props.body && { data: props.body }),
    };

   
    if (method.toUpperCase() === "GET") {
      delete config.data;
    }

    return axios(config)
      .then(async (res) => {
        const blob: Blob = res.data;
        // Detect JSON error payloads returned with blob responseType
        if (blob && blob.type && blob.type.includes("application/json")) {
          const text = await blob.text();
          let message = "Failed to download file.";
          try {
            const parsed = JSON.parse(text);
            message = parsed?.message || parsed?.ErrorDetails?.message || message;
          } catch {
            /* ignore */
          }
          toast.error(message, { theme: "colored" });
          throw new Error(message);
        }
        return blob;
      })
      .catch(async (err) => {
        if (this.handleSessionError(err)) throw err;
        // When responseType is blob, error body is also a Blob — parse message if possible
        const data = err?.response?.data;
        if (data instanceof Blob) {
          try {
            const text = await data.text();
            const parsed = JSON.parse(text);
            const message =
              parsed?.message ||
              parsed?.ErrorDetails?.message ||
              "Failed to download file.";
            toast.error(message, { theme: "colored" });
            throw new Error(message);
          } catch (e) {
            if (e instanceof Error && e.message !== "Failed to download file.") throw e;
          }
        }
        this.errorHandler(err);
        throw err;
      });
  },


  /**
   * Session ended (missing/expired/invalid token): log out and go to login.
   * 401, or a bare 403 "Access Denied" from Spring Security (no API status_code in the body).
   * App permission errors (403 with a message from our API) do NOT log out.
   */
  handleSessionError(error: any): boolean {
    const status = error?.response?.status;
    const data = error?.response?.data;
    // Blob bodies (file downloads) can't be inspected here, so only a 401 counts for them.
    const isBlob = typeof Blob !== "undefined" && data instanceof Blob;
    const isApiBody = !!data && typeof data === "object" && !isBlob && "status_code" in data;
    const sessionEnded = status === 401 || (status === 403 && !isApiBody && !isBlob);
    if (!sessionEnded || typeof window === "undefined") return false;
    this.clearLocalStorage();
    if (window.location.pathname !== "/login") {
      toast.error("Session expired. Please log in again.", { theme: "colored", toastId: "session-expired" });
      window.location.href = "/login";
    }
    return true;
  },

  clearLocalStorage() {
    if (typeof window !== "undefined") {
      localStorage.removeItem("token");
      localStorage.removeItem("loginUserImage");
      localStorage.removeItem("uuid");
      localStorage.removeItem("type");
    }
  },

  getBaseUrl(type?: string) {
    return environment.Base_URL;
  },
};
export default WebService;
